export default "__VITE_ASSET__5885ef36__"